import { FC } from 'react';
import { ReactComponent as AppLogo } from 'assets/images/app-logo.svg';
import { ReactComponent as ConstructionIcon } from 'assets/icons/construction.svg';

interface ComingSoonProps {
  showLogo?: boolean;
  className?: string;
  logoClassName?: string;
}

const ComingSoon: FC<ComingSoonProps> = ({
  showLogo = true,
  className,
  logoClassName = 'opacity-[30%] w-[26.9rem] h-[7.5rem] mb-2.4',
}) => {
  return (
    <div
      className={`flex flex-col justify-center items-center ${className ?? ''}`}
    >
      {showLogo && <AppLogo className={logoClassName} />}
      <div className="flex flex-row items-center">
        <ConstructionIcon />
        <span className="text-darkest-grey text-16 ml-0.5">Coming soon!</span>
      </div>
    </div>
  );
};

export default ComingSoon;
